import { PopupProps } from "@/types";
/* import { EditaDatosProfesionalCss } from "../styles"; */
import { motion } from "framer-motion";

const PopupFirma: React.FC<PopupProps> = ({ isOpen, children, className }) => {
  if (!isOpen) return null;

  return (
    <div className={`fixed inset-0 flex items-center justify-center z-50`}>
      <motion.div
        className={`relative p-2 rounded-xl shadow-lg shadow-zinc-700 border-b-2 border-r-4 border hover:border-teal-100 border-zinc-200 bg-zinc/80 backdrop-blur-3xl hover:shadow-lg
          w-[95%] sm:w-[85%] md:w-[70%] lg:w-[60%] xl:w-[35%] 
          max-h-[90vh] ${className}`}

        initial={{ opacity: 0, y: 30 }}   // empieza un poco más abajo
        whileInView={{ opacity: 1, y: 0 }} // sube suavemente
        transition={{ duration: 0.8 }} // animación más lenta y suave
      >

        {children}
      </motion.div>
    </div>
  );
};


export default PopupFirma;
